import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-guest-location',
  templateUrl: './user-guest-location.component.html',
  styleUrls: ['./user-guest-location.component.scss']
})
export class UserGuestLocationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
